import $ from 'jquery'

function update(input, trueIcon, falseIcon) {
  if (input.val() === 'true') {
    trueIcon.hide(0)
    falseIcon.show(0)
  } else {
    trueIcon.show(0)
    falseIcon.hide(0)
  }
}

export default function toggle(elem) {
  var groupId = elem.id
  console.log('toggle::', groupId)
  var input = $('#' + groupId + 'Not', elem)
  var trueIcon = $('#' + groupId + 'True', elem)
  var falseIcon = $('#' + groupId + 'False', elem)
  update(input, trueIcon, falseIcon)
  $(elem).click(function () {
    console.log('toggle::toggled', groupId)
    input.val(!(input.val() === 'true'))
    update(input, trueIcon, falseIcon)
  })
}
